import axios from 'axios';

// All API traffic goes through the nginx /api proxy (see docker/default.conf),
// which injects the amsterdam&partners bearer token server-side.
export const feedFactoryAxios = axios.create({
  baseURL: '/api',
});

export default feedFactoryAxios;
